<template lang="pug">
.question-list
  app-header.header

  //- パンくずリスト
  ul.breadcrumb
    li
      router-link(to="/") {{ $t('Home') }}
    li.active
      span {{ $t('Machine Order Shop') }}

  .row.margin-top
    .col-sm-12
      button.btn.btn-lg.btn-success(v-on:click="save()") 保存する
  .row.margin-top(v-if="isSearchComplete")
    .col-sm-6
      h3 遊技台発注対象店舗
      .machine-shop-box(v-for="(shop, index) in machineOrderShops")
        .row
          .col-sm-6
            p {{ shop.name }}
          .col-sm-2
            button.btn(v-if="index > 0" v-on:click="up(index)") ↑
          .col-sm-2
            button.btn(v-if="index < machineOrderShops.length - 1" v-on:click="down(index)") ↓
          .col-sm-2
            button.btn.btn-danger(v-on:click="remove(index)") →
    .col-sm-6
      h3 遊技台発注対象外店舗
      .machine-shop-box(v-for="(shop, index) in shops")
        .row
          .col-sm-6
            button.btn.btn-primary(v-on:click="add(index)") ←
          .col-sm-6
            p {{ shop.name }}
</template>
<script>
import AppHeader from './AppHeader'

export default {
  name: 'machine-order-shop',
  created () {
    console.log('created')
    this.getShops()
  },
  data () {
    return {
      shops: [],
      machineOrderShops: [],
      isSearchComplete: false
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getShops () {
      this.isSearchComplete = false
      console.log('getShops')

      var self = this
      var callback = function () {
        self.machineOrderShops = self.$store.getters.shopsAll.filter(shop => shop.attributes['sort-no']).map(shop => { return { id: shop.id, name: shop.attributes['shop-name'] } })
        self.shops = self.$store.getters.shopsAll.filter(shop => !shop.attributes['sort-no']).map(shop => { return { id: shop.id, name: shop.attributes['shop-name'] } })
        self.isSearchComplete = true
      }
      await this.$store.dispatch('SHOP_ALL_GET', { data: {sort: 'sort_no'}, callback: callback })
      .catch(err => {
        console.log(err)
        return
      })
    },
    add (index) {
      this.machineOrderShops.push(this.shops[index])
      this.shops.splice(index, 1)
      console.log(this.machineOrderShops)
      console.log(this.shops)
      this.$forceUpdate()
    },
    remove (index) {
      this.shops.push(this.machineOrderShops[index])
      this.machineOrderShops.splice(index, 1)
      this.$forceUpdate()
    },
    up (index) {
      if (index === 0) return
      const tmp = this.machineOrderShops[index]
      this.$set(this.machineOrderShops, index, this.machineOrderShops[index - 1])
      this.$set(this.machineOrderShops, index - 1, tmp)
    },
    down (index) {
      if (index === this.machineOrderShops.length - 1) return
      const tmp = this.machineOrderShops[index]
      this.$set(this.machineOrderShops, index, this.machineOrderShops[index + 1])
      this.$set(this.machineOrderShops, index + 1, tmp)
    },
    async save () {
      const res = await this.$store.dispatch('SORT_MACHINE_ORDER_SHOP', { remove_shop_ids: this.shops.map(shop => shop.id), machine_shops: this.machineOrderShops.map((shop, index) => { return { id: shop.id, sort_no: index + 1 } }) })
      console.log(res)
      if (res.status === 200) window.alert('保存しました')
      this.getShops()
    }
  }
}
</script>
<style>
  .machine-shop-box {
    border: 1px solid #888;
    padding: 8px;
    margin-bottom: 8px;
    border-radius: 8px;
  }
</style>


// WEBPACK FOOTER //
// MachineOrderShop.vue?951e6706